import React from 'react';
import { ShieldCheck, Cpu } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div>
            <div
              style={{
                fontWeight: 600,
                color: 'var(--text-primary)',
                marginBottom: '0.25rem',
              }}
            >
              Meme Mandi
            </div>
            <p style={{ fontSize: '0.8125rem' }}>
              Free-to-develop meme editor & community platform. Single source of truth in{' '}
              <code>/docs</code>.
            </p>
          </div>

          <div className="footer-links" style={{ fontSize: '0.8125rem' }}>
            <span
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
            >
              <ShieldCheck size={14} color="var(--accent-success)" />
              RLS Security Ready
            </span>
            <span
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
            >
              <Cpu size={14} color="var(--accent-secondary)" />
              React + Vite + TypeScript
            </span>
            <span>Version: 0.1.0-phase1</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
